import { render, staticRenderFns } from "./all_news.vue?vue&type=template&id=28bd4682&scoped=true&"
import script from "./all_news.vue?vue&type=script&lang=js&"
export * from "./all_news.vue?vue&type=script&lang=js&"
import style0 from "./all_news.vue?vue&type=style&index=0&id=28bd4682&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bd4682",
  null
  
)

export default component.exports